import { compareAsc } from "date-fns";
import { z } from "zod";
import { getSessionIDCollaborator } from "../../../../util/libLocalStorage";

// Esquema de validação regras e mensagens de erro
export const schema = z
	.object({
		id_fornecedor: z.number().int("Verifique o id_colaborador antes de continuar"),
		nome: z.string().nullable(),
		fantasia: z.string().min(3, "Por favor, informe o nome do fantasia, no mínimo 3 caracteres"),
		rua: z.string().nullable(),
		// .refine((value) => value.trim().length > 0, {
		// 	message: "O campo nome não pode conter apenas espaços em branco",
		// }),
		bairro: z.string().nullable(),
		numero: z.union([z.string(), z.null()]),
		// .refine((value) => value.length > 0 && value.trim().length === 0, {
		// 	message: "O campo nome não pode conter apenas espaços em branco",
		// }),
		complemento: z.string().nullable(),
		id_cidade: z.coerce
			.number({ invalid_type_error: "Selecione uma cidade" }) // Converte o valor para número
			.int("O campo id_cidade deve ser um número inteiro.") // Valida que é inteiro
			.refine((val) => val > 0, {
				// Garante que seja maior que 0
				message: "Selecione uma cidade válida",
			}),
		id_funcionario: z.number().int(),
		telefone_1: z.string().nullable(),
		telefone_2: z.string().nullable(),
		cpf: z.string().nullable(),
		rg: z.string().nullable(),
		cep: z.string().nullable(),
		pessoafisica: z.boolean(),
		ativo: z.boolean(),
		obs: z.string().nullable(),
		data: z.string(),
		email: z.string().nullable(),
		// email: z.lazy(() => z.string().email("Digite um e-mail válido").nullable().or(z.literal(""))),
	})
	.refine((data) => !(data.rua && data.rua.trim().length > 0) || (data.numero && data.numero.trim().length > 0), {
		message: "Campo número é obrigatório se a rua estiver preenchida",
		path: ["numero"],
	})
	.refine((data) => !(data.numero && data.numero.trim().length > 0) || (data.rua && data.rua.trim().length > 0), {
		message: "Campo rua é obrigatório se o número estiver preenchido",
		path: ["rua"],
	});

export const schemaDefaultValue = {
	id_fornecedor: 0,
	// id_funcionario: getSessionIDCollaborator(),
	id_funcionario: 1,
	id_cidade: 0,
	nome: "",
	fantasia: "",
	rua: "",
	numero: "",
	complemento: "",
	bairro: "",
	telefone_1: "",
	telefone_2: "",
	cpf: "",
	rg: "",
	cep: "",
	pessoafisica: true,
	ativo: true,
	data: "",
	email: "",
	obs: "",
};
